import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { SELECTOR_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div<{ $disabled: boolean }>`
    ${SELECTOR_RESET}

    display: flex;
    flex-direction: column;
    width: 100%;
    ${({ $disabled }) => $disabled && `opacity: 0.5;`}// TODO: Update to real disabled state
  `,

  TextContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size8};
    padding-bottom: ${SPACING.size16};
  `,

  Label: styled.label`
    ${TYPOGRAPHY.labelLargeMedium};
    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size8};
  `,

  Description: styled.p`
    ${TYPOGRAPHY.overlineMediumRegular};
    color: ${COLORS['charcoal-500']};
  `,
  Options: styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size12};
  `,

  Option: styled.div<{ $selected: boolean; $disabled?: boolean }>`
    position: relative;
    padding: ${SPACING.size12};
    border-radius: ${SPACING.size12};
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};

    border: 1px solid
      ${(props) => (props.$selected ? COLORS['charcoal-500'] : COLORS['charcoal-alpha-50'])};
    background-color: ${(props) => (props.$selected ? COLORS['charcoal-50'] : COLORS['white-50'])};
    transition: all 0.2s ease;

    &:hover {
      border: 1px solid
        ${(props) => (props.$disabled ? COLORS['charcoal-alpha-50'] : COLORS['charcoal-500'])};
    }
  `,

  OptionContent: styled.div<{ $disabled?: boolean }>`
    gap: ${SPACING.size12};
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  `,

  HiddenCheckbox: styled.input<{ $checked: boolean }>`
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;

    /* &:focus + label {
      outline: 2px solid ${COLORS['info-500']};
      outline-offset: 2px;
    } */
  `,

  Image: styled.img`
    width: 52px;
    height: 52px;
    border-radius: 4px;
  `,

  OptionTextsContainer: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${SPACING.size4};
  `,

  OptionLabel: styled.span`
    ${TYPOGRAPHY.labelMediumMedium};
    color: ${COLORS['charcoal-500']};
  `,

  OptionDescription: styled.span`
    ${TYPOGRAPHY.labelSmallRegular};
    color: ${COLORS['charcoal-300']};
  `,

  CustomCheckbox: styled.div<{ $checked: boolean }>`
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 2px solid ${(props) => (props.$checked ? COLORS['charcoal-500'] : COLORS['stone-200'])};
    background-color: ${(props) => (props.$checked ? COLORS['charcoal-500'] : COLORS['white-50'])};
    padding: ${SPACING.size4};

    display: flex;
    align-items: center;
    justify-content: center;
  `
};
